import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MasterService } from '../../../services/master.service';
import { StoreService } from '../../../services/store.service';
import * as words from '../../../services/language'

import { Favorite } from 'src/app/models/favorite.model';
import { daysAgo } from 'src/app/utils/date';
import { recentIcon } from 'src/app/utils/icons';

@Component({
    selector: 'favorites',
    templateUrl: './favorites.component.html',
    styleUrls: ['./favorites.component.scss'],
    standalone: false
})
export class FavoritesComponent implements OnInit, OnChanges {
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    // A list of user favorites.
    protected favorites: Array<Favorite> = []
    
    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        this.reset()
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
        

    }

    /*
    * Reset the favorites array
    */
    private reset = (): void => {
        this.favorites = null
    }

    /**
     * 
     */
    private fetch() {
        if (this.loading) {
            return
        }

        this.favorites = null
        this.favorites = []

        this.loading = true
        this.master.get(`favorites`, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.favorites = res.data.favs
        })
    }

    /**
     * 
     * @param resource 
     * @returns 
     */
    protected icon = (resource: string) => {
        return recentIcon(resource)
    }

    /**
     * 
     * @param e 
     */
    protected remove = (e: Event, index: number) => {
        if (!this.favorites || (this.favorites.length <= 0)) {
            return
        }

        if (index < 0 || (index > (this.favorites.length-1))) {
            return
        }

        const fav = this.favorites[index] 

        this.master.discard(`favorites?resource=${fav.resource}&i=${encodeURIComponent(fav.i)}`, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.favorites.splice(index, 1)
        })
    }
}
